import React from "react";
import { CategoryTab } from "../../atoms/CategoryTab";
import { TabList } from "./CategoryTabStrip.styles";
import type { CategoryTabStripProps } from "./CategoryTabStrip.types";

export const CategoryTabStrip: React.FC<CategoryTabStripProps> = ({
  options,
  activeKey,
  onChange,
  ariaLabel,
  className,
}) => (
  <TabList role="tablist" aria-label={ariaLabel} className={className}>
    {options.map((option) => (
      <CategoryTab
        key={option.key}
        label={option.label}
        count={option.count}
        soon={option.soon}
        isActive={option.key === activeKey}
        onClick={() => onChange(option.key)}
      />
    ))}
  </TabList>
);

export default CategoryTabStrip;
